// tax rates
const rates = [0.1, 0.12, 0.22, 0.24, 0.32, 0.35, 0.37];

// bracket data
const brackets = {
  y2018: {
    s: [0, 9525, 38700, 82500, 157500, 200000, 500000],
    mfj: [0, 19050, 77400, 165000, 315000, 400000, 600000],
    mfs: [0, 9525, 38700, 82500, 157500, 200000, 300000],
    hh: [0, 13600, 51800, 82500, 157500, 200000, 500000],
    qw: [0, 19050, 77400, 165000, 315000, 400000, 600000],
  },
  y2019: {
    s: [0, 9700, 39475, 84200, 160725, 204100, 510300],
    mfj: [0, 19400, 78950, 168400, 321450, 408200, 612350],
    mfs: [0, 9700, 39475, 84200, 160725, 204100, 306750],
    hh: [0, 13850, 52850, 84200, 160700, 204100, 510300],
    qw: [0, 19400, 78950, 168400, 321450, 408200, 612350],
  },
  y2020: {
    s: [0, 9875, 40125, 85525, 163300, 207350, 518400],
    mfj: [0, 19750, 80250, 171050, 326600, 414700, 622050],
    mfs: [0, 9875, 40125, 85525, 163300, 201350, 518400],
    hh: [0, 14100, 53700, 85500, 163300, 207350, 518400],
    qw: [0, 19750, 80250, 171050, 326600, 414700, 622050],
  },
};

export function calculateTaxBracket(
  income: number,
  year: number,
  filingStatus: string
) {
  const yearKey = "y" + year;
  const yearBrackets = brackets[yearKey];
  const statusArray = yearBrackets[filingStatus];

  let stdDeduction = 0
  switch (filingStatus) {
    case 's':
    case 'mfs':
      stdDeduction = 12000
      break
    case 'hh':
      stdDeduction = 18000
      break
    case 'mfj':
    case 'qw':
      stdDeduction = 24000
      break
  }

  let pretaxIncome = income - stdDeduction

  let index = statusArray.length - 1;
  while (statusArray[index] > pretaxIncome && index >= 0) {
    index--;
  }

  const rate = rates[index];

  if (rate === undefined || rate < 0) { 
      return 0;
    } else {
      return rate * 100;
  } 

}